export const TotalEarningIcon = () => {
  return (
    // icon code start

    <svg
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="34" cy="34" r="30" stroke="#E9ECEF" strokeWidth="2" />
      <path
        d="M34 4C41.3621 4 48.4672 6.70716 53.9628 11.6062C59.4584 16.5051 62.9606 23.2539 63.8029 30.5677C64.6452 37.8815 62.7687 45.2497 58.5307 51.2697C54.2926 57.2896 47.9888 61.541 40.8194 63.2146C33.65 64.8881 26.1155 63.8669 19.6502 60.3454C13.1849 56.8239 8.24019 51.0479 5.7574 44.1171C3.27461 37.1862 3.42708 29.5843 6.18578 22.7586C8.94448 15.9328 14.1168 10.3598 20.7181 7.10034"
        stroke="#0D0D10"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M26.1394 41.2307C25.7699 41.6411 25.803 42.2734 26.2134 42.643C26.6239 43.0125 27.2562 42.9794 27.6257 42.5689L26.1394 41.2307ZM41.8612 26.3211C41.8323 25.7696 41.3618 25.3459 40.8103 25.3748L31.8226 25.8458C31.2711 25.8747 30.8474 26.3452 30.8763 26.8968C30.9052 27.4483 31.3757 27.872 31.9273 27.8431L39.9163 27.4244L40.335 35.4134C40.3639 35.9649 40.8344 36.3886 41.386 36.3597C41.9375 36.3308 42.3612 35.8603 42.3323 35.3087L41.8612 26.3211ZM27.6257 42.5689L41.6057 27.0425L40.1195 25.7043L26.1394 41.2307L27.6257 42.5689Z"
        fill="#ADB5BD"
      />
    </svg>

    // icon code end
  );
};

export const TodayEarningIcon = () => {
  return (
    // icon code start

    <svg
      width="65"
      height="68"
      viewBox="0 0 65 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="31" cy="34" r="30" stroke="#E9ECEF" strokeWidth="2" />
      <path
        d="M30.9999 4C38.3621 4 45.4672 6.70716 50.9628 11.6062C56.4583 16.5051 59.9606 23.2539 60.8029 30.5677C61.6452 37.8815 59.7687 45.2497 55.5306 51.2697C51.2925 57.2896 44.9888 61.541 37.8194 63.2146C30.65 64.8881 23.1155 63.8669 16.6501 60.3454"
        stroke="#0D0D10"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M23.1394 41.2307C22.7699 41.6411 22.803 42.2734 23.2134 42.643C23.6239 43.0125 24.2562 42.9794 24.6257 42.5689L23.1394 41.2307ZM38.8612 26.3211C38.8323 25.7696 38.3618 25.3459 37.8103 25.3748L28.8226 25.8458C28.2711 25.8747 27.8474 26.3452 27.8763 26.8968C27.9052 27.4483 28.3757 27.872 28.9273 27.8431L36.9163 27.4244L37.335 35.4134C37.3639 35.9649 37.8344 36.3886 38.386 36.3597C38.9375 36.3308 39.3612 35.8603 39.3323 35.3087L38.8612 26.3211ZM24.6257 42.5689L38.6057 27.0425L37.1195 25.7043L23.1394 41.2307L24.6257 42.5689Z"
        fill="#ADB5BD"
      />
    </svg>

    // icon code end
  );
};

export const WeekEarningIcon = () => {
  return (
    // icon code start

    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="31" cy="34" r="30" stroke="#E9ECEF" strokeWidth="2" />
      <path
        d="M31 4C38.3622 4 45.4673 6.70716 50.9628 11.6062C56.4584 16.5051 59.9607 23.2539 60.803 30.5677C61.6453 37.8815 59.7688 45.2497 55.5307 51.2697"
        stroke="#0D0D10"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M23.1394 41.2307C22.7699 41.6411 22.803 42.2734 23.2134 42.643C23.6239 43.0125 24.2562 42.9794 24.6257 42.5689L23.1394 41.2307ZM38.8612 26.3211C38.8323 25.7696 38.3618 25.3459 37.8103 25.3748L28.8226 25.8458C28.2711 25.8747 27.8474 26.3452 27.8763 26.8968C27.9052 27.4483 28.3757 27.872 28.9273 27.8431L36.9163 27.4244L37.335 35.4134C37.3639 35.9649 37.8344 36.3886 38.386 36.3597C38.9375 36.3308 39.3612 35.8603 39.3323 35.3087L38.8612 26.3211ZM24.6257 42.5689L38.6057 27.0425L37.1195 25.7043L23.1394 41.2307L24.6257 42.5689Z"
        fill="#ADB5BD"
      />
    </svg>

    // icon code end
  );
};

export const MonthEarningIcon = () => {
  return (
    // icon code start

    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="31" cy="34" r="30" stroke="#E9ECEF" strokeWidth="2" />
      <path
        d="M31 4C38.3622 4 45.4673 6.70716 50.9628 11.6062C56.4584 16.5051 59.9607 23.2539 60.803 30.5677C61.6453 37.8815 59.7688 45.2497 55.5307 51.2697"
        stroke="#0D0D10"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M23.1394 41.2307C22.7699 41.6411 22.803 42.2734 23.2134 42.643C23.6239 43.0125 24.2562 42.9794 24.6257 42.5689L23.1394 41.2307ZM38.8612 26.3211C38.8323 25.7696 38.3618 25.3459 37.8103 25.3748L28.8226 25.8458C28.2711 25.8747 27.8474 26.3452 27.8763 26.8968C27.9052 27.4483 28.3757 27.872 28.9273 27.8431L36.9163 27.4244L37.335 35.4134C37.3639 35.9649 37.8344 36.3886 38.386 36.3597C38.9375 36.3308 39.3612 35.8603 39.3323 35.3087L38.8612 26.3211ZM24.6257 42.5689L38.6057 27.0425L37.1195 25.7043L23.1394 41.2307L24.6257 42.5689Z"
        fill="#ADB5BD"
      />
    </svg>

    // icon code end
  );
};

export const YearEarningIcon = () => {
  return (
    // icon code start

    <svg
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="34" cy="34" r="30" stroke="#E9ECEF" strokeWidth="2" />
      <path
        d="M34 4C41.3621 4 48.4672 6.70716 53.9628 11.6062C59.4584 16.5051 62.9606 23.2539 63.8029 30.5677C64.6452 37.8815 62.7687 45.2497 58.5307 51.2697C54.2926 57.2896 47.9888 61.541 40.8194 63.2146C33.65 64.8881 26.1155 63.8669 19.6502 60.3454C13.1849 56.8239 8.24019 51.0479 5.7574 44.1171C3.27461 37.1862 3.42708 29.5843 6.18578 22.7586C8.94448 15.9328 14.1168 10.3598 20.7181 7.10034"
        stroke="#0D0D10"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M26.1394 41.2307C25.7699 41.6411 25.803 42.2734 26.2134 42.643C26.6239 43.0125 27.2562 42.9794 27.6257 42.5689L26.1394 41.2307ZM41.8612 26.3211C41.8323 25.7696 41.3618 25.3459 40.8103 25.3748L31.8226 25.8458C31.2711 25.8747 30.8474 26.3452 30.8763 26.8968C30.9052 27.4483 31.3757 27.872 31.9273 27.8431L39.9163 27.4244L40.335 35.4134C40.3639 35.9649 40.8344 36.3886 41.386 36.3597C41.9375 36.3308 42.3612 35.8603 42.3323 35.3087L41.8612 26.3211ZM27.6257 42.5689L41.6057 27.0425L40.1195 25.7043L26.1394 41.2307L27.6257 42.5689Z"
        fill="#ADB5BD"
      />
    </svg>

    // icon code end
  );
};

export const UserIcon = () => {
  return (
    // icon code start

    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60" rx="8" fill="#0D0D10" />
      <path
        d="M31.6501 23.9996C31.6501 26.2363 29.8368 28.0496 27.6001 28.0496V29.5496C30.6653 29.5496 33.1501 27.0648 33.1501 23.9996H31.6501ZM27.6001 28.0496C25.3633 28.0496 23.5501 26.2363 23.5501 23.9996H22.0501C22.0501 27.0648 24.5349 29.5496 27.6001 29.5496V28.0496ZM23.5501 23.9996C23.5501 21.7628 25.3633 19.9496 27.6001 19.9496V18.4496C24.5349 18.4496 22.0501 20.9344 22.0501 23.9996H23.5501ZM27.6001 19.9496C29.8368 19.9496 31.6501 21.7628 31.6501 23.9996H33.1501C33.1501 20.9344 30.6653 18.4496 27.6001 18.4496V19.9496ZM24.0001 33.1496H31.2001V31.6496H24.0001V33.1496ZM31.2001 41.2496H24.0001V42.7496H31.2001V41.2496ZM24.0001 41.2496C21.7633 41.2496 19.9501 39.4363 19.9501 37.1996H18.4501C18.4501 40.2648 20.9349 42.7496 24.0001 42.7496V41.2496ZM35.2501 37.1996C35.2501 39.4363 33.4368 41.2496 31.2001 41.2496V42.7496C34.2653 42.7496 36.7501 40.2648 36.7501 37.1996H35.2501ZM31.2001 33.1496C33.4368 33.1496 35.2501 34.9628 35.2501 37.1996H36.7501C36.7501 34.1344 34.2653 31.6496 31.2001 31.6496V33.1496ZM24.0001 31.6496C20.9349 31.6496 18.4501 34.1344 18.4501 37.1996H19.9501C19.9501 34.9628 21.7633 33.1496 24.0001 33.1496V31.6496Z"
        fill="white"
      />
      <path
        d="M36.0001 20.3996C40.8001 20.3996 40.8001 27.5996 36.0001 27.5996"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M37.2001 32.3996C41.0401 32.3996 42.0001 33.8561 42.0001 35.9995C42.0001 40.7996 39.6001 41.3992 37.2001 41.3996"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>

    // icon code end
  );
};

export const UserHoverIcon = () => {
  return (
    // icon code start

    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60" rx="8" fill="white" />
      <path
        d="M31.6496 23.9996C31.6496 26.2364 29.8363 28.0496 27.5996 28.0496V29.5496C30.6648 29.5496 33.1496 27.0648 33.1496 23.9996H31.6496ZM27.5996 28.0496C25.3628 28.0496 23.5496 26.2364 23.5496 23.9996H22.0496C22.0496 27.0648 24.5344 29.5496 27.5996 29.5496V28.0496ZM23.5496 23.9996C23.5496 21.7629 25.3628 19.9496 27.5996 19.9496V18.4496C24.5344 18.4496 22.0496 20.9344 22.0496 23.9996H23.5496ZM27.5996 19.9496C29.8363 19.9496 31.6496 21.7629 31.6496 23.9996H33.1496C33.1496 20.9344 30.6648 18.4496 27.5996 18.4496V19.9496ZM23.9996 33.1496H31.1996V31.6496H23.9996V33.1496ZM31.1996 41.2496H23.9996V42.7496H31.1996V41.2496ZM23.9996 41.2496C21.7628 41.2496 19.9496 39.4364 19.9496 37.1996H18.4496C18.4496 40.2648 20.9344 42.7496 23.9996 42.7496V41.2496ZM35.2496 37.1996C35.2496 39.4364 33.4363 41.2496 31.1996 41.2496V42.7496C34.2648 42.7496 36.7496 40.2648 36.7496 37.1996H35.2496ZM31.1996 33.1496C33.4363 33.1496 35.2496 34.9629 35.2496 37.1996H36.7496C36.7496 34.1344 34.2648 31.6496 31.1996 31.6496V33.1496ZM23.9996 31.6496C20.9344 31.6496 18.4496 34.1344 18.4496 37.1996H19.9496C19.9496 34.9629 21.7628 33.1496 23.9996 33.1496V31.6496Z"
        fill="#222222"
      />
      <path
        d="M35.9996 20.3996C40.7996 20.3996 40.7996 27.5996 35.9996 27.5996"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M37.1996 32.3996C41.0396 32.3996 41.9996 33.8561 41.9996 35.9995C41.9996 40.7996 39.5996 41.3992 37.1996 41.3996"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>

    // icon code end
  );
};

export const ProductIcon = () => {
  return (
    // icon code start

    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60" rx="8" fill="#0D0D10" />
      <path
        d="M41.2701 28.18L40.1267 33.0566C39.1467 37.2683 37.2101 38.9716 33.5701 38.6216C32.9867 38.575 32.3567 38.47 31.6801 38.3066L29.7201 37.84C24.8551 36.685 23.3501 34.2816 24.4934 29.405L25.6367 24.5166C25.8701 23.525 26.1501 22.6616 26.5001 21.95C27.8651 19.1266 30.1867 18.3683 34.0834 19.29L36.0317 19.745C40.9201 20.8883 42.4134 23.3033 41.2701 28.18Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.57 38.6216C32.8466 39.1116 31.9366 39.5199 30.8283 39.8816L28.985 40.4883C24.3533 41.9816 21.915 40.7333 20.41 36.1016L18.9166 31.4933C17.4233 26.8616 18.66 24.4116 23.2916 22.9183L25.135 22.3116C25.6133 22.16 26.0683 22.0316 26.5 21.95C26.15 22.6616 25.87 23.525 25.6366 24.5166L24.4933 29.405C23.35 34.2816 24.855 36.6849 29.72 37.8399L31.68 38.3066C32.3566 38.47 32.9866 38.5749 33.57 38.6216Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.7467 25.9517L36.405 27.3867"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.6034 30.4667L32.9867 31.33"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const ProductHoverIcon = () => {
  return (
    // icon code start

    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60" rx="8" fill="white" />
      <path
        d="M41.2701 28.18L40.1267 33.0567C39.1467 37.2684 37.2101 38.9717 33.5701 38.6217C32.9867 38.575 32.3567 38.47 31.6801 38.3067L29.7201 37.84C24.8551 36.685 23.3501 34.2817 24.4934 29.405L25.6367 24.5167C25.8701 23.525 26.1501 22.6617 26.5001 21.95C27.8651 19.1267 30.1867 18.3684 34.0834 19.29L36.0317 19.745C40.9201 20.8884 42.4134 23.3034 41.2701 28.18Z"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.57 38.6216C32.8466 39.1116 31.9366 39.5199 30.8283 39.8816L28.985 40.4883C24.3533 41.9816 21.915 40.7333 20.41 36.1016L18.9166 31.4933C17.4233 26.8616 18.66 24.4116 23.2916 22.9183L25.135 22.3116C25.6133 22.16 26.0683 22.0316 26.5 21.95C26.15 22.6616 25.87 23.525 25.6366 24.5166L24.4933 29.405C23.35 34.2816 24.855 36.6849 29.72 37.8399L31.68 38.3066C32.3566 38.47 32.9866 38.5749 33.57 38.6216Z"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.7467 25.9517L36.405 27.3867"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.6034 30.4667L32.9867 31.33"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const OrderIcon = () => {
  return (
    // icon code start

    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60" rx="8" fill="#0D0D10" />
      <path
        d="M19 19H19.328C19.907 19 20.1968 19 20.433 19.1045C20.6412 19.1966 20.8195 19.345 20.9479 19.5331C21.0935 19.7464 21.146 20.0311 21.2511 20.6006L23.8889 34.8889L36.6238 34.8889C37.1793 34.8889 37.4575 34.8889 37.6873 34.7909C37.89 34.7044 38.0653 34.5648 38.1951 34.3867C38.3423 34.1849 38.4044 33.9142 38.5293 33.373L40.4472 25.0619C40.6361 24.2436 40.7306 23.8346 40.6268 23.5132C40.5357 23.2314 40.3448 22.9922 40.0907 22.8401C39.8009 22.6667 39.3815 22.6667 38.5418 22.6667H22.0556M37.3333 41C36.6583 41 36.1111 40.4528 36.1111 39.7778C36.1111 39.1028 36.6583 38.5556 37.3333 38.5556C38.0083 38.5556 38.5556 39.1028 38.5556 39.7778C38.5556 40.4528 38.0083 41 37.3333 41ZM25.1111 41C24.4361 41 23.8889 40.4528 23.8889 39.7778C23.8889 39.1028 24.4361 38.5556 25.1111 38.5556C25.7861 38.5556 26.3333 39.1028 26.3333 39.7778C26.3333 40.4528 25.7861 41 25.1111 41Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const OrderHoverIcon = () => {
  return (
    // icon code start

    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60" rx="8" fill="#0D0D10" />
      <path
        d="M19 19H19.328C19.907 19 20.1968 19 20.433 19.1045C20.6412 19.1966 20.8195 19.345 20.9479 19.5331C21.0935 19.7464 21.146 20.0311 21.2511 20.6006L23.8889 34.8889L36.6238 34.8889C37.1793 34.8889 37.4575 34.8889 37.6873 34.7909C37.89 34.7044 38.0653 34.5648 38.1951 34.3867C38.3423 34.1849 38.4044 33.9142 38.5293 33.373L40.4472 25.0619C40.6361 24.2436 40.7306 23.8346 40.6268 23.5132C40.5357 23.2314 40.3448 22.9922 40.0907 22.8401C39.8009 22.6667 39.3815 22.6667 38.5418 22.6667H22.0556M37.3333 41C36.6583 41 36.1111 40.4528 36.1111 39.7778C36.1111 39.1028 36.6583 38.5556 37.3333 38.5556C38.0083 38.5556 38.5556 39.1028 38.5556 39.7778C38.5556 40.4528 38.0083 41 37.3333 41ZM25.1111 41C24.4361 41 23.8889 40.4528 23.8889 39.7778C23.8889 39.1028 24.4361 38.5556 25.1111 38.5556C25.7861 38.5556 26.3333 39.1028 26.3333 39.7778C26.3333 40.4528 25.7861 41 25.1111 41Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const EventIcon = () => {
  return (
    // icon code start

    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60" rx="8" fill="#0D0D10" />
      <path
        d="M32.2 19C34.4 19 35.5 20.111 35.5 22.333V30.088C35.5 32.277 33.949 33.1241 32.046 31.98L30.594 31.1C30.264 30.902 29.736 30.902 29.406 31.1L27.954 31.98C26.051 33.1241 24.5 32.277 24.5 30.088V22.333C24.5 20.111 25.6 19 27.8 19H32.2Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.302 22.289C20.551 22.916 19 25.226 19 29.89V33.223C19 38.778 21.2 41.0001 26.7 41.0001H33.3001C38.8001 41.0001 41.0001 38.778 41.0001 33.223V29.89C41.0001 25.149 39.3941 22.828 35.5001 22.256"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const EventHoverIcon = () => {
  return (
    // icon code start

    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60" rx="8" fill="white" />
      <path
        d="M32.2 19C34.4 19 35.5 20.111 35.5 22.333V30.088C35.5 32.277 33.949 33.1241 32.046 31.98L30.594 31.1C30.264 30.902 29.736 30.902 29.406 31.1L27.954 31.98C26.051 33.1241 24.5 32.277 24.5 30.088V22.333C24.5 20.111 25.6 19 27.8 19H32.2Z"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.302 22.289C20.551 22.916 19 25.226 19 29.89V33.223C19 38.778 21.2 41.0001 26.7 41.0001H33.3001C38.8001 41.0001 41.0001 38.778 41.0001 33.223V29.89C41.0001 25.149 39.3941 22.828 35.5001 22.256"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const PendingPaymentIcon = () => {
  return (
    // icon code start

    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60" rx="8" fill="#0D0D10" />
      <path
        d="M18.3333 27.6666H41.6666"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.473 39.9164H23.5113C19.3697 39.9164 18.3196 38.8897 18.3196 34.7947V25.2047C18.3196 21.4947 19.183 20.3047 22.438 20.1181C22.7647 20.1064 23.1263 20.0947 23.5113 20.0947H36.473C40.6146 20.0947 41.6647 21.1214 41.6647 25.2164V30.3614"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 34.6666H27.6667"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.6666 37C41.6666 37.875 41.4216 38.7034 40.99 39.4034C40.185 40.7567 38.7033 41.6667 37 41.6667C35.2966 41.6667 33.815 40.7567 33.01 39.4034C32.5783 38.7034 32.3333 37.875 32.3333 37C32.3333 34.4217 34.4216 32.3334 37 32.3334C39.5783 32.3334 41.6666 34.4217 41.6666 37Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.7307 34.5109H36.1682C35.2616 34.5109 35.1917 35.3259 35.6812 35.7695L38.2178 38.0746C38.7072 38.5183 38.6373 39.3333 37.7307 39.3333H36.1682C35.2616 39.3333 35.1917 38.5183 35.6812 38.0746L38.2178 35.7695C38.7072 35.3259 38.6373 34.5109 37.7307 34.5109Z"
        stroke="white"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const PendingPaymentHoverIcon = () => {
  return (
    // icon code start

    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60" rx="8" fill="white" />
      <path
        d="M18.3333 27.6666H41.6666"
        stroke="#222222"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.473 39.9164H23.5113C19.3697 39.9164 18.3196 38.8897 18.3196 34.7947V25.2047C18.3196 21.4947 19.183 20.3047 22.438 20.1181C22.7647 20.1064 23.1263 20.0947 23.5113 20.0947H36.473C40.6146 20.0947 41.6647 21.1214 41.6647 25.2164V30.3614"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 34.6666H27.6667"
        stroke="#222222"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.6666 37C41.6666 37.875 41.4216 38.7034 40.99 39.4034C40.185 40.7567 38.7033 41.6667 37 41.6667C35.2966 41.6667 33.815 40.7567 33.01 39.4034C32.5783 38.7034 32.3333 37.875 32.3333 37C32.3333 34.4217 34.4216 32.3334 37 32.3334C39.5783 32.3334 41.6666 34.4217 41.6666 37Z"
        stroke="#222222"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.7307 34.5109H36.1682C35.2616 34.5109 35.1917 35.3259 35.6812 35.7695L38.2178 38.0746C38.7072 38.5183 38.6373 39.3333 37.7307 39.3333H36.1682C35.2616 39.3333 35.1917 38.5183 35.6812 38.0746L38.2178 35.7695C38.7072 35.3259 38.6373 34.5109 37.7307 34.5109Z"
        stroke="#222222"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const ReceivedPaymentIcon = () => {
  return (
    // icon code start

    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60" rx="8" fill="#0D0D10" />
      <path
        d="M18.3333 27.6666H41.6666"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.473 39.9164H23.5113C19.3697 39.9164 18.3196 38.8897 18.3196 34.7947V25.2047C18.3196 21.4947 19.183 20.3047 22.438 20.1181C22.7647 20.1064 23.1263 20.0947 23.5113 20.0947H36.473C40.6146 20.0947 41.6647 21.1214 41.6647 25.2164V30.3614"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 34.6666H27.6667"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.6666 37C41.6666 37.875 41.4216 38.7034 40.99 39.4034C40.185 40.7567 38.7033 41.6667 37 41.6667C35.2966 41.6667 33.815 40.7567 33.01 39.4034C32.5783 38.7034 32.3333 37.875 32.3333 37C32.3333 34.4217 34.4216 32.3334 37 32.3334C39.5783 32.3334 41.6666 34.4217 41.6666 37Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.1816 36.9994L36.3366 38.1544L38.8216 35.8561"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const ReceivedPaymentHoverIcon = () => {
  return (
    // icon code start

    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60" rx="8" fill="white" />
      <path
        d="M18.3333 27.6666H41.6666"
        stroke="#222222"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.473 39.9164H23.5113C19.3697 39.9164 18.3196 38.8897 18.3196 34.7947V25.2047C18.3196 21.4947 19.183 20.3047 22.438 20.1181C22.7647 20.1064 23.1263 20.0947 23.5113 20.0947H36.473C40.6146 20.0947 41.6647 21.1214 41.6647 25.2164V30.3614"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 34.6666H27.6667"
        stroke="#222222"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.6666 37C41.6666 37.875 41.4216 38.7034 40.99 39.4034C40.185 40.7567 38.7033 41.6667 37 41.6667C35.2966 41.6667 33.815 40.7567 33.01 39.4034C32.5783 38.7034 32.3333 37.875 32.3333 37C32.3333 34.4217 34.4216 32.3334 37 32.3334C39.5783 32.3334 41.6666 34.4217 41.6666 37Z"
        stroke="#222222"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.1816 36.9994L36.3366 38.1544L38.8216 35.8561"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};
export const UsFlagIcon = () => {
  return (
    // icon code start

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <g clipPath="url(#clip0_2882_18566)">
        <path
          d="M12.0001 0.75C9.88135 0.751693 7.80618 1.35165 6.01343 2.4808H17.9703C16.1823 1.35461 14.1132 0.754774 12.0001 0.75V0.75Z"
          fill="#B22234"
        />
        <path
          d="M6.01318 2.48047C5.2409 2.96936 4.53108 3.55055 3.89941 4.21118H20.1135C19.4726 3.54864 18.7527 2.96738 17.9701 2.48047H6.01318Z"
          fill="white"
        />
        <path
          d="M3.89981 4.21191C3.3892 4.74277 2.93196 5.32249 2.53467 5.94272H21.4787C21.0815 5.3225 20.6244 4.74278 20.1139 4.21191H3.89981Z"
          fill="#B22234"
        />
        <path
          d="M2.53448 5.94232C2.1794 6.4915 1.87288 7.0706 1.61841 7.67303H22.3734C22.1257 7.07133 21.8263 6.49226 21.4785 5.94232H2.53448Z"
          fill="white"
        />
        <path
          d="M1.61838 7.67303C1.38803 8.23415 1.20344 8.81297 1.06641 9.40384H22.9328C22.7933 8.81275 22.6063 8.23392 22.3734 7.67303H1.61838Z"
          fill="#B22234"
        />
        <path
          d="M1.06656 9.4043C0.930665 9.97325 0.839355 10.5519 0.793457 11.1351H23.2135C23.1652 10.5517 23.0713 9.97305 22.9329 9.4043H1.06656Z"
          fill="white"
        />
        <path
          d="M0.793304 11.1348C0.767763 11.4226 0.753317 11.7112 0.75 12.0001C0.751095 12.2889 0.763311 12.5776 0.786621 12.8655H23.2067C23.2322 12.5777 23.2467 12.289 23.25 12.0001C23.2489 11.7113 23.2367 11.4226 23.2134 11.1348H0.793304Z"
          fill="#B22234"
        />
        <path
          d="M0.786621 12.8652C0.834987 13.4486 0.928808 14.0273 1.06723 14.596H22.9336C23.0695 14.0271 23.1608 13.4484 23.2067 12.8652H0.786621Z"
          fill="white"
        />
        <path
          d="M1.06738 14.5957C1.20682 15.1868 1.3939 15.7656 1.62677 16.3265H22.3818C22.6121 15.7654 22.7967 15.1866 22.9337 14.5957H1.06738Z"
          fill="#B22234"
        />
        <path
          d="M1.62659 16.327C1.87428 16.9287 2.17372 17.5077 2.52151 18.0577H21.4655C21.8206 17.5085 22.1271 16.9294 22.3816 16.327H1.62659Z"
          fill="white"
        />
        <path
          d="M2.52148 18.0577C2.91866 18.6779 3.37578 19.2576 3.88626 19.7885H20.1003C20.611 19.2576 21.0682 18.6779 21.4655 18.0577H2.52148Z"
          fill="#B22234"
        />
        <path
          d="M3.88623 19.7881C4.52711 20.4506 5.24698 21.0319 6.02966 21.5188H17.9865C18.7588 21.0299 19.4686 20.4487 20.1003 19.7881H3.88623Z"
          fill="white"
        />
        <path
          d="M6.02979 21.5195C7.81782 22.6457 9.88689 23.2456 12 23.2503C14.1187 23.2486 16.1939 22.6487 17.9867 21.5195H6.02979Z"
          fill="#B22234"
        />
        <path
          d="M12 0.75C9.01631 0.75 6.15483 1.93526 4.04505 4.04505C1.93526 6.15483 0.75 9.01631 0.75 12C0.751472 12.2973 0.764727 12.5944 0.789734 12.8906H12.8906V0.794586C12.5945 0.767959 12.2973 0.753086 12 0.75V0.75Z"
          fill="#3C3B6E"
        />
        <path
          d="M7.97396 1.50847C7.82406 1.56319 7.67534 1.62109 7.52791 1.68214L7.69225 1.80702L7.5811 2.16618L7.87554 1.94636L8.17858 2.17671L8.06478 1.805L8.36782 1.57878H7.99547L7.97396 1.50847ZM9.88225 1.20117L9.76536 1.57875H9.39431L9.69466 1.80704L9.58349 2.16616L9.87791 1.94635L10.181 2.17669L10.0672 1.80505L10.3702 1.57875H9.99788L9.88225 1.20117V1.20117ZM11.8846 1.20117L11.7677 1.57875H11.3967L11.697 1.80704L11.5859 2.16616L11.8803 1.94635L12.1834 2.17669L12.0695 1.80505L12.3726 1.57875H12.0003L11.8846 1.20117ZM5.07943 3.14726C5.02652 3.18671 4.97397 3.22663 4.92177 3.26701L5.17501 3.45955L5.07943 3.14726ZM6.87867 2.484L6.76178 2.86158H6.39073L6.69108 3.08987L6.57991 3.44899L6.87433 3.22918L7.1774 3.45952L7.06359 3.08788L7.36661 2.86158H6.9943L6.87867 2.484ZM8.88106 2.484L8.76417 2.86158H8.39311L8.69347 3.08987L8.5823 3.44899L8.87672 3.22918L9.17978 3.45952L9.06597 3.08788L9.369 2.86158H8.99669L8.88106 2.484V2.484ZM10.8834 2.484L10.7666 2.86158H10.3955L10.6959 3.08987L10.5847 3.44899L10.8791 3.22918L11.1822 3.45952L11.0684 3.08788L11.3714 2.86158H10.9991L10.8834 2.484V2.484ZM3.98143 4.11415C3.87047 4.23161 3.76204 4.35145 3.65624 4.47358L3.57631 4.73176L3.87075 4.51194L4.17379 4.74229L4.05999 4.37068L4.36302 4.14436H3.99068L3.98143 4.11415ZM5.87748 3.76678L5.76059 4.14436H5.38954L5.68989 4.37265L5.57872 4.73176L5.87313 4.51196L6.1762 4.7423L6.06239 4.37066L6.36542 4.14436H5.99311L5.87748 3.76678V3.76678ZM7.87986 3.76678L7.76297 4.14436H7.39192L7.69227 4.37265L7.5811 4.73176L7.87552 4.51196L8.17858 4.7423L8.06478 4.37066L8.36781 4.14436H7.99549L7.87986 3.76678V3.76678ZM9.88225 3.76678L9.76536 4.14436H9.39431L9.69466 4.37265L9.58349 4.73176L9.87791 4.51196L10.181 4.7423L10.0672 4.37066L10.3702 4.14436H9.99788L9.88225 3.76678V3.76678ZM11.8846 3.76678L11.7677 4.14436H11.3967L11.697 4.37265L11.5859 4.73176L11.8803 4.51196L12.1834 4.7423L12.0695 4.37066L12.3726 4.14436H12.0003L11.8846 3.76678V3.76678ZM2.95888 5.32704C2.85523 5.46518 2.75477 5.60569 2.65758 5.74846L2.57518 6.0146L2.86952 5.79478L3.17266 6.02513L3.05886 5.65352L3.3618 5.4272H2.98955L2.95888 5.32704ZM4.87629 5.04961L4.75939 5.42718H4.38834L4.6887 5.65548L4.57752 6.01459L4.87194 5.79479L5.17501 6.02513L5.0612 5.65348L5.36423 5.42718H4.99191L4.87629 5.04961V5.04961ZM6.87867 5.04961L6.76178 5.42718H6.39073L6.69108 5.65548L6.57991 6.01459L6.87433 5.79479L7.1774 6.02513L7.06359 5.65348L7.36661 5.42718H6.9943L6.87867 5.04961V5.04961ZM8.88106 5.04961L8.76417 5.42718H8.39311L8.69347 5.65548L8.5823 6.01459L8.87672 5.79479L9.17978 6.02513L9.06597 5.65348L9.369 5.42718H8.99669L8.88106 5.04961V5.04961ZM10.8834 5.04961L10.7666 5.42718H10.3955L10.6959 5.65548L10.5847 6.01459L10.8791 5.79479L11.1822 6.02513L11.0684 5.65348L11.3714 5.42718H10.9991L10.8834 5.04961V5.04961ZM2.08144 6.71003C2.0142 6.83605 1.94937 6.96333 1.88698 7.09181L2.17144 7.30797L2.05764 6.93635L2.36067 6.71003H2.08144ZM3.8751 6.33244L3.75821 6.71001H3.38715L3.68751 6.93831L3.57634 7.29742L3.87075 7.07762L4.17382 7.30796L4.06001 6.93631L4.36304 6.71001H3.99072L3.8751 6.33244ZM5.87748 6.33244L5.76059 6.71001H5.38954L5.68989 6.93831L5.57872 7.29742L5.87313 7.07762L6.1762 7.30796L6.06239 6.93631L6.36542 6.71001H5.99311L5.87748 6.33244V6.33244ZM7.87986 6.33244L7.76297 6.71001H7.39192L7.69227 6.93831L7.5811 7.29742L7.87552 7.07762L8.17858 7.30796L8.06478 6.93631L8.36781 6.71001H7.99549L7.87986 6.33244ZM9.88225 6.33244L9.76536 6.71001H9.39431L9.69466 6.93831L9.58349 7.29742L9.87791 7.07762L10.181 7.30796L10.0672 6.93631L10.3702 6.71001H9.99788L9.88225 6.33244V6.33244ZM11.8846 6.33244L11.7677 6.71001H11.3967L11.697 6.93831L11.5859 7.29742L11.8803 7.07762L12.1834 7.30796L12.0695 6.93631L12.3726 6.71001H12.0003L11.8846 6.33244ZM2.8739 7.61522L2.75701 7.99279H2.38596L2.68632 8.22109L2.57515 8.5802L2.86956 8.3604L3.17262 8.59074L3.05882 8.21909L3.36185 7.99279H2.98953L2.8739 7.61522V7.61522ZM4.87629 7.61522L4.75939 7.99279H4.38834L4.6887 8.22109L4.57752 8.5802L4.87194 8.3604L5.17501 8.59074L5.0612 8.21909L5.36423 7.99279H4.99191L4.87629 7.61522ZM6.87867 7.61522L6.76178 7.99279H6.39073L6.69108 8.22109L6.57991 8.5802L6.87433 8.3604L7.1774 8.59074L7.06359 8.21909L7.36661 7.99279H6.9943L6.87867 7.61522ZM8.88106 7.61522L8.76417 7.99279H8.39311L8.69347 8.22109L8.5823 8.5802L8.87672 8.3604L9.17978 8.59074L9.06597 8.21909L9.369 7.99279H8.99669L8.88106 7.61522V7.61522ZM10.8834 7.61522L10.7666 7.99279H10.3955L10.6959 8.22109L10.5847 8.5802L10.8791 8.3604L11.1822 8.59074L11.0684 8.21909L11.3714 7.99279H10.9991L10.8834 7.61522V7.61522ZM1.87271 8.89804L1.75582 9.27562H1.38477L1.68512 9.50392L1.57395 9.86303L1.86837 9.64322L2.17143 9.87357L2.05763 9.50192L2.36065 9.27562H1.98834L1.87271 8.89804ZM3.8751 8.89804L3.75821 9.27562H3.38715L3.68751 9.50392L3.57634 9.86303L3.87075 9.64322L4.17382 9.87357L4.06001 9.50192L4.36304 9.27562H3.99072L3.8751 8.89804ZM5.87748 8.89804L5.76059 9.27562H5.38954L5.68989 9.50392L5.57872 9.86303L5.87313 9.64322L6.1762 9.87357L6.06239 9.50192L6.36542 9.27562H5.99311L5.87748 8.89804V8.89804ZM7.87986 8.89804L7.76297 9.27562H7.39192L7.69227 9.50392L7.5811 9.86303L7.87552 9.64322L8.17858 9.87357L8.06478 9.50192L8.36781 9.27562H7.99549L7.87986 8.89804ZM9.88225 8.89804L9.76536 9.27562H9.39431L9.69466 9.50392L9.58349 9.86303L9.87791 9.64322L10.181 9.87357L10.0672 9.50192L10.3702 9.27562H9.99788L9.88225 8.89804V8.89804ZM11.8846 8.89804L11.7677 9.27562H11.3967L11.697 9.50392L11.5859 9.86303L11.8803 9.64322L12.1834 9.87357L12.0695 9.50192L12.3726 9.27562H12.0003L11.8846 8.89804ZM2.8739 10.1809L2.75701 10.5584H2.38596L2.68632 10.7867L2.57515 11.1459L2.86956 10.9261L3.17262 11.1564L3.05882 10.7848L3.36185 10.5584H2.98953L2.8739 10.1809V10.1809ZM4.87629 10.1809L4.75939 10.5584H4.38834L4.6887 10.7867L4.57752 11.1459L4.87194 10.9261L5.17501 11.1564L5.0612 10.7848L5.36423 10.5584H4.99191L4.87629 10.1809ZM6.87867 10.1809L6.76178 10.5584H6.39073L6.69108 10.7867L6.57991 11.1459L6.87433 10.9261L7.1774 11.1564L7.06359 10.7848L7.36661 10.5584H6.9943L6.87867 10.1809ZM8.88106 10.1809L8.76417 10.5584H8.39311L8.69347 10.7867L8.5823 11.1459L8.87672 10.9261L9.17978 11.1564L9.06597 10.7848L9.369 10.5584H8.99669L8.88106 10.1809V10.1809ZM10.8834 10.1809L10.7666 10.5584H10.3955L10.6959 10.7867L10.5847 11.1459L10.8791 10.9261L11.1822 11.1564L11.0684 10.7848L11.3714 10.5584H10.9991L10.8834 10.1809V10.1809ZM1.87271 11.4637L1.75582 11.8412H1.38477L1.68512 12.0695L1.57395 12.4286L1.86837 12.2088L2.17143 12.4392L2.05763 12.0675L2.36065 11.8412H1.98834L1.87271 11.4637V11.4637ZM3.8751 11.4637L3.75821 11.8412H3.38715L3.68751 12.0695L3.57634 12.4286L3.87075 12.2088L4.17382 12.4392L4.06001 12.0675L4.36304 11.8412H3.99072L3.8751 11.4637V11.4637ZM5.87748 11.4637L5.76059 11.8412H5.38954L5.68989 12.0695L5.57872 12.4286L5.87313 12.2088L6.1762 12.4392L6.06239 12.0675L6.36542 11.8412H5.99311L5.87748 11.4637V11.4637ZM7.87986 11.4637L7.76297 11.8412H7.39192L7.69227 12.0695L7.5811 12.4286L7.87552 12.2088L8.17858 12.4392L8.06478 12.0675L8.36781 11.8412H7.99549L7.87986 11.4637V11.4637ZM9.88225 11.4637L9.76536 11.8412H9.39431L9.69466 12.0695L9.58349 12.4286L9.87791 12.2088L10.181 12.4392L10.0672 12.0675L10.3702 11.8412H9.99788L9.88225 11.4637V11.4637ZM11.8846 11.4637L11.7677 11.8412H11.3967L11.697 12.0695L11.5859 12.4286L11.8803 12.2088L12.1834 12.4392L12.0695 12.0675L12.3726 11.8412H12.0003L11.8846 11.4637V11.4637Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2882_18566">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>

    // icon code end
  );
};

export const TotalUserIcon = () => {
  return (
    // icon code start

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none">
      <rect
        width="80"
        height="80"
        rx="8"
        className="fill-[#0d0d10] group-hover:fill-white"
      />
      <path
        d="M52 30.32C51.88 30.3 51.74 30.3 51.62 30.32C48.86 30.22 46.66 27.96 46.66 25.16C46.66 22.3 48.96 20 51.82 20C54.68 20 56.98 22.32 56.98 25.16C56.96 27.96 54.76 30.22 52 30.32Z"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.94 44.88C52.68 45.34 55.7 44.86 57.82 43.44C60.64 41.56 60.64 38.48 57.82 36.6C55.68 35.18 52.62 34.7 49.88 35.18"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.94 30.32C28.06 30.3 28.2 30.3 28.32 30.32C31.08 30.22 33.28 27.96 33.28 25.16C33.28 22.3 30.98 20 28.12 20C25.26 20 22.96 22.32 22.96 25.16C22.98 27.96 25.18 30.22 27.94 30.32Z"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30 44.88C27.26 45.34 24.24 44.86 22.12 43.44C19.3 41.56 19.3 38.48 22.12 36.6C24.26 35.18 27.32 34.7 30.06 35.18"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40 45.26C39.88 45.24 39.74 45.24 39.62 45.26C36.86 45.16 34.66 42.9 34.66 40.1C34.66 37.24 36.96 34.94 39.82 34.94C42.68 34.94 44.98 37.26 44.98 40.1C44.96 42.9 42.76 45.18 40 45.26Z"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.18 51.56C31.36 53.44 31.36 56.52 34.18 58.4C37.38 60.54 42.62 60.54 45.82 58.4C48.64 56.52 48.64 53.44 45.82 51.56C42.64 49.44 37.38 49.44 34.18 51.56Z"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};
export const ActiveUserIcon = () => {
  return (
    // icon code start

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none">
      <rect
        width="80"
        height="80"
        rx="8"
        className="fill-[#0d0d10] group-hover:fill-white"
      />
      <path
        d="M44.88 54.1L47.92 57.14L54 51.06"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.32 37.74C40.12 37.72 39.88 37.72 39.66 37.74C34.9 37.58 31.12 33.68 31.12 28.88C31.1 23.98 35.08 20 39.98 20C44.88 20 48.86 23.98 48.86 28.88C48.86 33.68 45.06 37.58 40.32 37.74Z"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.98 59.62C36.34 59.62 32.72 58.7 29.96 56.86C25.12 53.62 25.12 48.34 29.96 45.12C35.46 41.44 44.48 41.44 49.98 45.12"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};
export const NewUserIcon = () => {
  return (
    // icon code start

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none">
      <rect
        width="80"
        height="80"
        rx="8"
        className="fill-[#0d0d10] group-hover:fill-white"
      />
      <path
        d="M53 55H45"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49 59V51"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.3199 37.74C40.1199 37.72 39.8799 37.72 39.6599 37.74C34.8999 37.58 31.1199 33.68 31.1199 28.88C31.0999 23.98 35.0799 20 39.9799 20C44.8799 20 48.8599 23.98 48.8599 28.88C48.8599 33.68 45.0599 37.58 40.3199 37.74Z"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.98 59.62C36.34 59.62 32.72 58.7 29.96 56.86C25.12 53.62 25.12 48.34 29.96 45.12C35.46 41.44 44.48 41.44 49.98 45.12"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};
export const TotalProductIcon = () => {
  return (
    // icon code start

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none">
      <rect
        width="80"
        height="80"
        rx="8"
        className="fill-[#0d0d10] group-hover:fill-white"
      />
      <path
        d="M59.3199 36.8801L57.3599 45.2401C55.6799 52.4601 52.3599 55.3801 46.1199 54.7801C45.1199 54.7001 44.0399 54.5201 42.8799 54.2401L39.5199 53.4401C31.1799 51.4601 28.5999 47.3401 30.5599 38.9801L32.5199 30.6001C32.9199 28.9001 33.3999 27.4201 33.9999 26.2001C36.3399 21.3601 40.3199 20.0601 46.9999 21.6401L50.3399 22.4201C58.7199 24.3801 61.2799 28.5201 59.3199 36.8801Z"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.1198 54.7795C44.8798 55.6195 43.3198 56.3195 41.4198 56.9395L38.2598 57.9795C30.3198 60.5395 26.1398 58.3995 23.5598 50.4595L20.9998 42.5595C18.4398 34.6195 20.5598 30.4195 28.4998 27.8595L31.6598 26.8195C32.4798 26.5595 33.2598 26.3395 33.9998 26.1995C33.3998 27.4195 32.9198 28.8995 32.5198 30.5995L30.5598 38.9795C28.5998 47.3395 31.1798 51.4595 39.5198 53.4395L42.8798 54.2395C44.0398 54.5195 45.1198 54.6995 46.1198 54.7795Z"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.2797 33.0602L50.9797 35.5202"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.3199 40.7998L45.1199 42.2798"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};
export const TotalPaymentPendingIcon = () => {
  return (
    // icon code start

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none">
      <rect
        width="80"
        height="80"
        rx="8"
        className="fill-[#0d0d10] group-hover:fill-white"
      />
      <path
        d="M59.3199 36.8801L57.3599 45.2401C55.6799 52.4601 52.3599 55.3801 46.1199 54.7801C45.1199 54.7001 44.0399 54.5201 42.8799 54.2401L39.5199 53.4401C31.1799 51.4601 28.5999 47.3401 30.5599 38.9801L32.5199 30.6001C32.9199 28.9001 33.3999 27.4201 33.9999 26.2001C36.3399 21.3601 40.3199 20.0601 46.9999 21.6401L50.3399 22.4201C58.7199 24.3801 61.2799 28.5201 59.3199 36.8801Z"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.1198 54.7795C44.8798 55.6195 43.3198 56.3195 41.4198 56.9395L38.2598 57.9795C30.3198 60.5395 26.1398 58.3995 23.5598 50.4595L20.9998 42.5595C18.4398 34.6195 20.5598 30.4195 28.4998 27.8595L31.6598 26.8195C32.4798 26.5595 33.2598 26.3395 33.9998 26.1995C33.3998 27.4195 32.9198 28.8995 32.5198 30.5995L30.5598 38.9795C28.5998 47.3395 31.1798 51.4595 39.5198 53.4395L42.8798 54.2395C44.0398 54.5195 45.1198 54.6995 46.1198 54.7795Z"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.2797 33.0602L50.9797 35.5202"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.3199 40.7998L45.1199 42.2798"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};
export const TotalSiteVisitorIcon = () => {
  return (
    // icon code start

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none">
      <rect
        width="80"
        height="80"
        rx="8"
        className="fill-[#0d0d10] group-hover:fill-white"
      />
      <path
        d="M27.8 50H52.18C55.98 50 57.98 48 57.98 44.2V20H21.98V44.2C22 48 24 50 27.8 50Z"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 20H60"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32 60L40 56V50"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48 60L40 56"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31 38L37.3 32.74C37.8 32.32 38.46 32.44 38.8 33L41.2 37C41.54 37.56 42.2 37.66 42.7 37.26L49 32"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const TotalOrderIcon = () => {
  return (
    // icon code start

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none">
      <rect
        width="80"
        height="80"
        rx="8"
        className="fill-[#0d0d10] group-hover:fill-white"
      />
      <path
        d="M21.1429 21.1429H21.7052C22.6979 21.1429 23.1947 21.1429 23.5995 21.3219C23.9565 21.4799 24.2621 21.7343 24.4822 22.0567C24.7319 22.4223 24.8217 22.9105 25.0019 23.8867L29.524 48.381L51.3552 48.3809C52.3074 48.3809 52.7844 48.3809 53.1783 48.2129C53.5257 48.0647 53.8263 47.8253 54.0488 47.5201C54.3011 47.1741 54.4076 46.7101 54.6217 45.7823L57.9097 31.5346C58.2334 30.1319 58.3954 29.4308 58.2174 28.8798C58.0613 28.3967 57.7341 27.9866 57.2984 27.7259C56.8016 27.4286 56.0827 27.4286 54.6431 27.4286H26.381M52.5715 58.8571C51.4144 58.8571 50.4763 57.9191 50.4763 56.7619C50.4763 55.6047 51.4144 54.6667 52.5715 54.6667C53.7287 54.6667 54.6668 55.6047 54.6668 56.7619C54.6668 57.9191 53.7287 58.8571 52.5715 58.8571ZM31.6191 58.8571C30.462 58.8571 29.5239 57.9191 29.5239 56.7619C29.5239 55.6047 30.462 54.6667 31.6191 54.6667C32.7763 54.6667 33.7144 55.6047 33.7144 56.7619C33.7144 57.9191 32.7763 58.8571 31.6191 58.8571Z"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const TotalEventIcon = () => {
  return (
    // icon code start

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none">
      <rect
        width="80"
        height="80"
        rx="8"
        className="fill-[#0d0d10] group-hover:fill-white"
      />
      <path
        d="M43.7713 21.1428C47.5428 21.1428 49.4285 23.0474 49.4285 26.8566V40.1509C49.4285 43.9035 46.7696 45.3555 43.5073 43.3943L41.0182 41.8858C40.4525 41.5463 39.5473 41.5463 38.9816 41.8858L36.4925 43.3943C33.2302 45.3555 30.5713 43.9035 30.5713 40.1509V26.8566C30.5713 23.0474 32.457 21.1428 36.2285 21.1428H43.7713Z"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.2324 26.781C23.8021 27.8559 21.1432 31.8159 21.1432 39.8114V45.5251C21.1432 55.048 24.9146 58.8572 34.3432 58.8572H45.6576C55.0862 58.8572 58.8576 55.048 58.8576 45.5251V39.8114C58.8576 31.6839 56.1045 27.705 49.429 26.7245"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};
export const TotalPaymentReceivedIcon = () => {
  return (
    // icon code start

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none">
      <rect
        width="80"
        height="80"
        rx="8"
        className="fill-[#0d0d10] group-hover:fill-white"
      />
      <path
        d="M19.9993 36H59.9993"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.096 56.9996H28.8761C21.7761 56.9996 19.976 55.2396 19.976 48.2196V31.7796C19.976 25.4196 21.4561 23.3796 27.0361 23.0596C27.5961 23.0396 28.2161 23.0196 28.8761 23.0196H51.096C58.196 23.0196 59.9961 24.7796 59.9961 31.7996V40.6196"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.9995 48H35.9995"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59.9997 52C59.9997 53.5 59.5797 54.92 58.8397 56.12C57.4597 58.44 54.9197 60 51.9997 60C49.0797 60 46.5397 58.44 45.1597 56.12C44.4197 54.92 43.9997 53.5 43.9997 52C43.9997 47.58 47.5797 44 51.9997 44C56.4197 44 59.9997 47.58 59.9997 52Z"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.8823 51.9991L50.8623 53.9791L55.1223 50.0391"
        className="stroke-white group-hover:stroke-black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};
export const PrimaryLogo = () => {
  return (
    // icon code start

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="37"
      viewBox="0 0 24 37"
      fill="none">
      <g clipPath="url(#clip0_3376_25773)">
        <path
          d="M23.4565 7.51942C23.2057 7.34012 22.8957 7.26385 22.5904 7.30632C22.4325 7.33285 22.2819 7.39231 22.1485 7.48084C21.9494 7.65707 21.7614 7.84542 21.5855 8.04482C20.9142 8.80308 20.3944 9.68298 20.0543 10.6369C19.9414 10.967 19.8521 11.3046 19.787 11.6473C14.6341 9.55025 8.86562 9.55025 3.7127 11.6473C3.6237 11.1074 3.47299 10.5794 3.26354 10.0739C3.02424 9.51344 2.72128 8.98241 2.36063 8.49122C2.05691 8.05315 1.71906 7.63975 1.35024 7.25488C1.18606 7.20666 1.01511 7.18557 0.84413 7.19242C0.541347 7.20788 0.248938 7.30779 0 7.48084C0.185074 7.23862 0.285731 6.94246 0.286582 6.63763C0.285129 6.33346 0.184514 6.03807 0 5.79625C0.241393 5.98305 0.537982 6.08441 0.843212 6.08441C1.14844 6.08441 1.44503 5.98305 1.68642 5.79625C1.54505 5.97945 1.45209 6.19531 1.41613 6.42391C1.38017 6.65251 1.40237 6.88648 1.48067 7.10424C1.80498 7.43302 2.17647 7.71164 2.58291 7.93092C3.21945 8.27261 3.86885 8.62074 4.38231 8.381C5.28615 7.95939 5.18052 6.00017 5.16949 5.79442C5.15847 5.58866 5.13 5.38934 5.13 5.38934C5.08956 5.10151 5.02378 4.8178 4.93343 4.54154C4.74329 4.42164 4.5267 4.35008 4.30255 4.33311C4.07841 4.31614 3.85351 4.35427 3.64749 4.44417C3.88625 4.25456 4.05567 3.99137 4.12943 3.69553C4.20318 3.39969 4.17712 3.08777 4.05532 2.80827C4.24493 3.04703 4.50812 3.21646 4.80396 3.29021C5.0998 3.36396 5.41172 3.33791 5.69122 3.2161C5.45567 3.40864 5.28691 3.67062 5.20899 3.9647C5.17125 4.11719 5.16007 4.27503 5.17592 4.43131C5.43403 4.75188 5.68663 5.0403 5.92545 5.29933C6.26438 5.66674 6.54545 5.93587 6.63731 6.02221C7.4401 6.78184 8.32465 7.6177 9.10724 7.48084C9.77868 7.36602 10.1342 6.57792 10.7937 5.12021C11.1851 4.25388 11.4948 3.35286 11.7186 2.42892C11.6537 2.30103 11.5691 2.18417 11.4679 2.08263C11.2498 1.87035 10.97 1.7327 10.6687 1.6895C10.971 1.64889 11.2516 1.51049 11.4679 1.29545C11.6822 1.08019 11.8205 0.800938 11.8619 0.5C11.9016 0.802327 12.0398 1.08317 12.255 1.29912C12.4713 1.51417 12.7519 1.65256 13.0542 1.69317C12.7506 1.72864 12.4684 1.86744 12.255 2.0863C12.1628 2.18561 12.0877 2.29952 12.0328 2.42341C12.1223 3.35154 12.3498 4.26111 12.7079 5.12205C13.2213 6.35656 13.6172 7.30724 14.3943 7.48268C15.5333 7.7417 16.8413 6.18295 17.5421 5.34709C17.8594 4.96868 18.1448 4.56468 18.3954 4.13922C18.3925 3.90903 18.3321 3.68321 18.2199 3.48224C18.1076 3.28127 17.9469 3.11149 17.7525 2.9883C18.0432 3.08024 18.3562 3.07353 18.6427 2.96921C18.9293 2.86489 19.1733 2.66881 19.3369 2.41146C19.2451 2.70223 19.2519 3.01516 19.3562 3.30167C19.4605 3.58817 19.6565 3.83223 19.9138 3.99593C19.6228 3.90408 19.3097 3.91054 19.0228 4.0143C18.8929 4.06408 18.772 4.13449 18.6646 4.22281C18.5016 4.84652 18.4259 5.48978 18.4395 6.13427C18.4616 7.12537 18.4799 7.94378 19.0017 8.26986C19.776 8.75484 21.1584 7.84274 21.3632 7.70772C21.5637 7.57522 21.7519 7.42488 21.9253 7.25855C21.9753 7.11086 21.9969 6.95501 21.9887 6.79929C21.9678 6.4941 21.8408 6.20586 21.6296 5.98455C21.8868 6.14876 22.191 6.22337 22.495 6.19679C22.799 6.17021 23.0857 6.04393 23.3105 5.83759C23.1452 6.09443 23.07 6.39891 23.0966 6.70317C23.1232 7.00744 23.2501 7.29424 23.4575 7.5185L23.4565 7.51942Z"
          fill="#D3AC46"
        />
        <path
          d="M22.053 25.271C22.0531 25.3687 22.0208 25.4636 21.9612 25.541C19.1388 29.1772 16.3128 32.8133 13.4831 36.4495C13.471 36.4652 13.4554 36.478 13.4376 36.4867C13.4197 36.4955 13.4001 36.5 13.3803 36.5H12.5839C12.5492 36.5 12.5159 36.4863 12.4913 36.4619C12.4667 36.4374 12.4528 36.4043 12.4525 36.3696V13.0389C12.4528 12.9231 12.499 12.8121 12.5809 12.7303C12.6629 12.6485 12.774 12.6026 12.8898 12.6026H21.569C21.6844 12.6026 21.7951 12.6483 21.8768 12.7297C21.9586 12.8111 22.0048 12.9216 22.0053 13.037C22.0114 14.6904 22.0184 16.3416 22.0264 17.9907C22.0268 18.0482 22.0157 18.1052 21.994 18.1585C21.9722 18.2117 21.9401 18.2602 21.8996 18.301C21.859 18.3418 21.8108 18.3742 21.7577 18.3963C21.7046 18.4184 21.6476 18.4297 21.5901 18.4297H19.2524C19.1366 18.4295 19.0257 18.3833 18.9439 18.3014C18.8621 18.2194 18.8161 18.1083 18.8161 17.9925V16.172C18.8159 16.0562 18.7697 15.9452 18.6877 15.8634C18.6058 15.7816 18.4947 15.7357 18.3789 15.7357H16.0155C15.8997 15.7357 15.7887 15.7816 15.7067 15.8634C15.6247 15.9452 15.5785 16.0562 15.5783 16.172V27.8777C15.5782 27.905 15.5865 27.9316 15.6023 27.9538C15.618 27.976 15.6403 27.9927 15.666 28.0016C15.6918 28.0106 15.7196 28.0112 15.7457 28.0035C15.7718 27.9958 15.7949 27.9801 15.8116 27.9586C16.7136 26.8159 17.6153 25.6736 18.5167 24.5315C18.629 24.4086 18.6981 24.2523 18.7134 24.0865C18.7286 23.9206 18.6892 23.7544 18.6012 23.613C18.5255 23.5034 18.4222 23.4157 18.3017 23.3589C18.1812 23.3021 18.0478 23.2783 17.915 23.2897H17.0103C16.8597 23.2897 16.7154 23.2299 16.6089 23.1234C16.5024 23.017 16.4426 22.8726 16.4426 22.722V20.6158C16.4426 20.4653 16.5024 20.3209 16.6089 20.2144C16.7154 20.108 16.8597 20.0482 17.0103 20.0482H21.5956C21.7113 20.0484 21.8221 20.0943 21.9042 20.1758C21.9862 20.2573 22.0328 20.3679 22.0337 20.4836L22.053 25.271Z"
          fill="#D3AC46"
        />
        <path
          d="M10.3399 12.6062H2.04006C1.96885 12.6062 1.89835 12.6203 1.83259 12.6476C1.76683 12.6749 1.70711 12.7149 1.65685 12.7654C1.60659 12.8158 1.56678 12.8756 1.53969 12.9415C1.51261 13.0074 1.4988 13.0779 1.49904 13.1491C1.50455 14.3965 1.50945 15.6441 1.51374 16.8921C1.51498 16.9663 1.54082 17.0381 1.58722 17.096L3.03115 18.8798C3.05318 18.9053 3.06702 18.9367 3.07086 18.9702C3.0747 19.0036 3.06837 19.0374 3.0527 19.0672C3.03702 19.0969 3.01272 19.1213 2.98299 19.137C2.95325 19.1528 2.91946 19.1592 2.88602 19.1554L1.8885 19.0635C1.84281 19.059 1.79669 19.0642 1.75312 19.0786C1.70954 19.0931 1.66949 19.1165 1.63555 19.1474C1.60161 19.1783 1.57454 19.216 1.55608 19.2581C1.53763 19.3001 1.52821 19.3455 1.52843 19.3914C1.53762 21.3424 1.54619 23.2934 1.55415 25.2443C1.55495 25.3639 1.5946 25.4799 1.66713 25.575L10.1176 36.4431C10.1332 36.4631 10.1531 36.4793 10.1758 36.4904C10.1986 36.5016 10.2236 36.5074 10.249 36.5074H10.8919C10.9363 36.5074 10.9788 36.4897 11.0102 36.4584C11.0415 36.427 11.0591 36.3845 11.0591 36.3402V13.3135C11.0591 13.2196 11.0404 13.1267 11.0042 13.0401C10.9679 12.9535 10.9147 12.875 10.8478 12.8091C10.7808 12.7433 10.7014 12.6915 10.6142 12.6566C10.527 12.6218 10.4338 12.6047 10.3399 12.6062ZM7.91774 27.8796C7.91671 27.9133 7.90552 27.9459 7.88563 27.9731C7.86574 28.0003 7.83809 28.0209 7.80631 28.0321C7.77452 28.0433 7.74008 28.0447 7.70752 28.036C7.67495 28.0273 7.64577 28.009 7.62381 27.9834L4.79657 24.4085C4.72279 24.312 4.68335 24.1937 4.68451 24.0723V22.5236C4.6846 22.4455 4.7089 22.3693 4.75406 22.3055C4.79922 22.2417 4.86302 22.1934 4.93671 22.1673C5.0104 22.1413 5.09035 22.1386 5.16558 22.1598C5.24082 22.181 5.30764 22.225 5.35687 22.2857L7.88375 25.4087C7.90783 25.4384 7.92111 25.4753 7.92141 25.5135L7.91774 27.8796ZM7.62381 20.8914L4.72125 17.3091C4.69744 17.2794 4.68448 17.2425 4.68451 17.2044V16.4457C4.68439 16.3529 4.70257 16.2609 4.73801 16.1751C4.77346 16.0893 4.82547 16.0113 4.89107 15.9457C4.95667 15.88 5.03458 15.8279 5.12034 15.7923C5.2061 15.7567 5.29802 15.7384 5.39086 15.7384H7.21047C7.30335 15.7384 7.39532 15.7567 7.48113 15.7923C7.56694 15.8278 7.64491 15.8799 7.71058 15.9456C7.77626 16.0113 7.82836 16.0892 7.8639 16.175C7.89944 16.2609 7.91774 16.3528 7.91774 16.4457V20.7894C7.91636 20.823 7.90491 20.8553 7.88489 20.8823C7.86487 20.9092 7.83721 20.9295 7.80549 20.9405C7.77378 20.9515 7.73949 20.9527 7.70708 20.944C7.67468 20.9352 7.64566 20.9169 7.62381 20.8914Z"
          fill="#D3AC46"
        />
      </g>
      <defs>
        <clipPath id="clip0_3376_25773">
          <rect
            width="23.4565"
            height="36"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>

    // icon code end
  );
};
